import logoUrl from '../assets/truheight-logo.svg';

/** TruHeight wordmark (reversed: caramel and cream, for charcoal backgrounds). Paths copied from truheightvitamins.com and fingerprint-verified. */
export function BrandLogo({ height = 26 }: { height?: number }) {
  return <img src={logoUrl} alt="TruHeight" style={{ height, width: 'auto', display: 'block' }} />;
}

export const T_PATH = 'M26.42,15.23c-.11-1.49-.39-2.96-.84-4.39-.36-1.15-.94-2.21-1.72-3.13-.75-.84-1.69-1.49-2.76-1.87-1.28-.44-2.63-.65-3.99-.61v22.52c0,1.29.02,2.42.07,3.37.02.81.16,1.61.42,2.38.21.6.62,1.1,1.17,1.41.71.34,1.49.5,2.27.46v.31H5.8v-.31c.78.04,1.56-.12,2.27-.46.55-.31.96-.82,1.17-1.41.26-.77.4-1.57.42-2.38.04-.96.07-2.08.07-3.37V5.23c-1.36-.03-2.71.18-3.99.62-1.06.39-2.01,1.03-2.76,1.87-.78.92-1.36,1.98-1.72,3.13-.45,1.42-.73,2.89-.84,4.38H.06L.95,4.83h24.95l.88,10.4h-.36Z';

/** The "T" from the TruHeight wordmark, used as a compact brand mark. */
export function Monogram({ size = 22, color = '#E0B997' }: { size?: number; color?: string }) {
  return <svg width={size} height={size} viewBox="-3 3 33 34" aria-hidden="true"><path d={T_PATH} fill={color} /></svg>;
}
